module.exports = __webpack_public_path__ + "img/2(1).d0cf05cb.png";